import { animateLaptopScreens } from './animate-laptop-screens.js';
import { animateServiceText } from './init-advantages-extra-services.js';

export function initBookMonitorSection() {
    document.querySelectorAll('[data-book-monitor]').forEach((section) => {
        const tabs = Array.from(section.querySelectorAll('[data-book-monitor-tab]'));
        const contents = Array.from(section.querySelectorAll('[data-book-monitor-content]'));
        const screens = Array.from(section.querySelectorAll('[data-screen]'));
        let requestId = 0;
        let animations = [];

        if (!tabs.length || !contents.length) return;
        contents.forEach(item => { item.inert = item.getAttribute('aria-hidden') === 'true'; });

        const activate = async (tab) => {
            if (tab.getAttribute('aria-selected') === 'true') return;
            const id = ++requestId;
            const key = tab.dataset.bookMonitorTab;
            const content = contents.find(item => item.dataset.bookMonitorContent === key);
            let next = screens.find(item => item.dataset.screen === key);
            if (!content) return;

            tabs.forEach(item => {
                const active = item === tab;
                item.classList.toggle('book-monitor__tab--active', active);
                item.setAttribute('aria-selected', String(active));
                item.tabIndex = active ? 0 : -1;
            });
            try {
                if (next) await next.decode();
            } catch {
                // Keep the previous screen if the CMS image cannot load.
                next = null;
            }
            if (id !== requestId) return;
            animations.forEach(animation => animation.cancel());
            animations = [];
            const previous = screens.find(item => item.classList.contains('book-monitor__screen-image--active'));
            const previousContent = contents.find(item => item.classList.contains('book-monitor__content--active'));
            contents.forEach(item => {
                const active = item === content;
                item.classList.toggle('book-monitor__content--active', active);
                item.setAttribute('aria-hidden', String(!active));
                item.inert = !active;
            });
            if (next) {
                screens.forEach(item => item.classList.toggle('book-monitor__screen-image--active', item === next));
                if (previous && previous !== next) animations.push(...animateLaptopScreens(previous, next));
            }
            if (previousContent && previousContent !== content) {
                animations.push(...animateServiceText(previousContent, content));
            }
            try {
                await Promise.all(animations.map(animation => animation.finished));
                if (id === requestId) {
                    animations.forEach(animation => animation.cancel());
                    animations = [];
                }
            } catch {
                // A newer selection cancels the previous transition.
            }
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activate(tab));
            tab.addEventListener('keydown', (event) => {
                const isRtl = window.getComputedStyle(section).direction === 'rtl';
                let nextIndex;

                switch (event.key) {
                case 'ArrowRight':
                    nextIndex = index + (isRtl ? -1 : 1);
                    break;
                case 'ArrowLeft':
                    nextIndex = index + (isRtl ? 1 : -1);
                    break;
                case 'ArrowDown':
                    nextIndex = index + 1;
                    break;
                case 'ArrowUp':
                    nextIndex = index - 1;
                    break;
                case 'Home':
                    nextIndex = 0;
                    break;
                case 'End':
                    nextIndex = tabs.length - 1;
                    break;
                default:
                    return;
                }

                event.preventDefault();
                const nextTab = tabs[(nextIndex + tabs.length) % tabs.length];
                nextTab.focus();
                activate(nextTab);
            });
        });
    });
}
